import applyStyles from "../../utils/applyStyles";
import createMessageBusClient from "../../lib/messageBusClient";
import { dispatchLivePostUpdate } from "../../transport/nextPage";
import makeTransportContext from "../../utils/makeTransportContext";
import renderPage from "../../utils/renderPage";

function renderLoaded(container, data) {
    const postOnPage = container.parentElement.querySelector(`[elid="${data.postId}"]`);
    const postInData = data.posts_html.includes(`elid="${data.postId}"`);
    const renderAfterElement = true;

    if (!postInData) {
        return;
    }

    if (postOnPage && data.action === "edit") {
        postOnPage.remove();
        renderPage(container, data.posts_html, renderAfterElement);
    } else if (!postOnPage) {
        applyStyles(data.css);
        renderPage(container, data.posts_html, renderAfterElement);
    }
}

export default function sectionLiveBlog(context, container) {
    const { settings } = context;
    const { site, section } = settings;
    const dataSectionIds = container.getAttribute("data-section-ids");
    const sectionIds = [];

    if (dataSectionIds) {
        sectionIds.push(...dataSectionIds.split(","));
    } else if (section && section.id) {
        sectionIds.push(section.id.toString());
    }

    new Set(sectionIds).forEach((sectionId) => {
        const channel = `${site.id}:section-${sectionId}`;
        createMessageBusClient(settings, channel, (messageData) => {
            const { postId } = messageData;
            dispatchLivePostUpdate({ postId, ...makeTransportContext(container, context) }).then(
                (responseData) => {
                    responseData.action = messageData.action;
                    responseData.postId = postId;
                    renderLoaded(container, responseData);
                }
            );
        });
    });
}
